import { Container } from "@/components/layout/Container"
import { Eyebrow } from "@/components/shared/Eyebrow"

interface ServiceConditionsProps {
	name: string
	/** Padecimientos en los que se recomienda ampliamente este servicio. */
	conditions: string[]
}

/**
 * "Padecimientos recomendados" para un servicio (p. ej. dieta personalizada).
 * Mismo look que `ProductConditions` (Eyebrow + chips), pero recibe una lista
 * estática en vez de derivarla de los tratamientos — los chips son solo texto
 * descriptivo, no enlazan a `/tratamientos/:slug`.
 */
export function ServiceConditions({ name, conditions }: ServiceConditionsProps): React.JSX.Element | null {
	if (conditions.length === 0) return null

	return (
		<section className="bg-background">
			<Container className="pb-24">
				<div className="mx-auto max-w-2xl text-center">
					<Eyebrow align="center">Padecimientos recomendados</Eyebrow>
					<h2 className="mt-3 text-balance text-2xl font-semibold tracking-tight sm:text-3xl md:text-4xl">
						¿Cuándo se recomienda {name.toLowerCase()}?
					</h2>
					<p className="mt-4 text-pretty text-muted-foreground">
						Se recomienda ampliamente como complemento en estos padecimientos.
					</p>
				</div>

				<ul className="mt-10 flex flex-wrap justify-center gap-3">
					{conditions.map(condition => (
						<li
							key={condition}
							className="inline-flex h-11 items-center rounded-full border border-border bg-card px-5 text-sm font-medium ring-foreground/10"
						>
							{condition}
						</li>
					))}
				</ul>
			</Container>
		</section>
	)
}
